<template>
  <div>
    <common-header title="My Advertisers" :breadcrumbs="breadcrumbs" divided>
      <template #btn>
        <el-col style="width: 65px">
          <el-button
            class="btn btn-default btn-outline-pink"
            v-if="
              CONSTANT.USER_LEVEL_FILTER.ONLY_ADMIN.includes(
                userInfo.service.user_level
              )
            "
            @click="
              showDialog({
                type:
                  CONSTANT.DIALOG_TYPE[
                    !advertiserId ? 'ADVERTISER' : 'CAMPAIGN'
                  ],
              })
            "
          >
            <i class="fas fa-user-plus"></i>
          </el-button>
        </el-col>
      </template>
    </common-header>

    <el-table
      :data="
        data.filter(
          (item) =>
            !search || item.name.toLowerCase().includes(search.toLowerCase())
        )
      "
      row-key="_id"
      :row-style="{ cursor: 'pointer' }"
      @row-contextmenu="rowContextMenu"
      @row-click="rowClick"
      style="font-size: 18px"
      :empty-text="
        !advertiserId
          ? `No advertiser! Let's create a new advertiser!`
          : `No campaign! Let's create a new campaign!`
      "
      border
    >
      <el-table-column
        v-if="!advertiserId"
        prop="icon"
        label="Icon"
        width="100px"
        sortable
      >
        <template slot-scope="{ row }">
          <el-avatar
            :key="row._id + row.icon"
            v-if="row.icon"
            :size="avatarSize"
            :fit="'fit'"
          >
            <img :src="row.icon" :width="avatarSize" :height="avatarSize" />
          </el-avatar>
          <el-avatar
            v-else
            :key="row._id + row.icon"
            :size="avatarSize"
            icon="el-icon-user-solid"
            :fit="'scale-down'"
          >
          </el-avatar>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="Name"
        min-width="300"
        sortable
      ></el-table-column>
      <el-table-column
        v-if="advertiserId"
        key="1"
        prop="start"
        label="StartDate"
        min-width="300"
        sortable
      ></el-table-column>
      <el-table-column
        v-if="advertiserId"
        prop="end"
        label="EndDate"
        min-width="300"
        sortable
      ></el-table-column>
      <el-table-column align="right" width="250">
        <template slot="header" slot-scope="{ row }">
          <el-input v-model="search" placeholder="search" />
        </template>
        <template slot-scope="{ row }">
          <el-button
            class="btn btn-outline-pink"
            v-if="
              CONSTANT.USER_LEVEL_FILTER.MID.includes(
                userInfo.service.user_level
              )
            "
            @click="
              showDialog({
                type:
                  CONSTANT.DIALOG_TYPE[
                    !advertiserId ? 'ADVERTISER' : 'CAMPAIGN'
                  ],
                row,
              })
            "
          >
            <el-tooltip
              class="item"
              effect="dark"
              content="Edit"
              placement="bottom"
            >
              <i class="fas fa-pen"></i>
            </el-tooltip>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <dialogs></dialogs>
    <context-menus></context-menus>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import CommonHeader from "@/components/base/header";
import Dialogs from "@/components/common/dialogs/index";
import ContextMenus from "@/components/common/contextMenus/index";
export default {
  data() {
    return {
      advertiserId: this.$route.params.advertiserId,
      breadcrumbs: null,
      search: "",
      avatarSize: 50,
    };
  },
  components: {
    CommonHeader,
    Dialogs,
    ContextMenus,
  },
  computed: {
    ...mapState({
      advertisers: (state) => state.advertiser.advertisers,
      userInfo: (state) => state.user.userInfo,
    }),
    data() {
      if (this.advertiserId) {
        const advertiser = _.find(
          this.advertisers,
          (advertiser) => advertiser._id === this.advertiserId
        );
        let campaigns;
        if (advertiser) {
          campaigns = advertiser.campaigns.map((ele) => {
            ele.start = new Date(ele.start).toString();
            ele.end = new Date(ele.end).toString();
            return ele;
          });
        }
        return advertiser ? campaigns : [];
      } else {
        return this.advertisers;
      }
    },
  },
  async created() {
    if (!this.advertisers.length) {
      await store.dispatch("advertiser/getAdvertisers");
    }
    await store.dispatch("asset/getAssets");
    if (this.advertiserId) {
      let currentItem = _.find(
        this.advertisers,
        (item) => item._id === this.advertiserId
      );

      let routers = this.setHeaderRouter([], currentItem._id);
      let currentPath = { name: currentItem.name };
      let sameLayerPath = _.filter(
        this.advertisers,
        (item) => currentItem._id != item._id
      ).map((item) => ({
        name: item.name,
        path: `/advertiser/${item._id}`,
      }));

      this.breadcrumbs = { routers, currentPath, sameLayerPath };
    }
  },
  methods: {
    ...mapActions({
      showContextMenu: "showContextMenu",
      showDialog: "showDialog",
    }),
    setHeaderRouter(array, id) {
      array.push({ name: "My Advertisers", path: "/advertisers" });
      return array;
    },
    rowContextMenu(row, col) {
      if (col.label) {
        this.showContextMenu({
          type:
            CONSTANT.MENU_TYPE[!this.advertiserId ? "ADVERTISER" : "CAMPAIGN"],
          row,
        });
      }
    },
    rowClick(row, col) {
      if (col.label) {
        if (!this.advertiserId) {
          this.$router.push({ path: "/advertiser/" + row._id });
        } else {
          this.$router.push({
            path: "/creatives",
            query: { advertiser: this.advertiserId, campaign: row._id },
          });
        }
      }
    },
  },
};
</script>

<style></style>
